import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { noop } from 'lodash';

import Campaign from './Campaign';
import CampaignLoadingImage from './campaignList-loading.png';
import PropTypeCampaign from '../utilities/propTypes/PropTypeCampaign';

const CampaignList = ({ campaigns, isLoading, onDiscardCampaign }) => {
  if (isLoading) {
    return <img src={CampaignLoadingImage} alt="Campaign List Loading" />;
  }

  const campaignRows = campaigns.length ? (
    campaigns.map(campaign => (
      <Campaign
        key={campaign.transactionHash}
        {...campaign}
        onDiscardCampaign={onDiscardCampaign}
      />
    ))
  ) : (
    <p>
      You do not have any campaigns.<br />
      <NavLink exact href="/" to="/">
        Create One!
      </NavLink>
    </p>
  );
  return (
    <div className="campaign-list">
      <div className="headers">
        <div className="label">Name</div>
        <div className="label">Status</div>
        <div className="label">Token Name</div>
        <div className="label">Tokens Per Code</div>
        <div className="label">Date Created</div>
      </div>
      {campaignRows}
    </div>
  );
};

CampaignList.displayName = 'CampaignList';

CampaignList.defaultProps = {
  campaigns: [],
  isLoading: false,
  onDiscardCampaign: noop,
};

CampaignList.propTypes = {
  campaigns: PropTypes.arrayOf(PropTypes.shape(PropTypeCampaign)),
  isLoading: PropTypes.bool,
  onDiscardCampaign: PropTypes.func,
};

export default CampaignList;



// WEBPACK FOOTER //
// ./src/components/CampaignList.js